<template>
	<node-view-wrapper class="text-parser-chip">
		<div class="content-display pa-1">
			<div class="value-text">{{ text }}</div>
		</div>
	</node-view-wrapper>
</template>

<script>
import { NodeViewWrapper, nodeViewProps } from '@tiptap/vue-2';
import { b64DecodeUnicode } from '@/components/common/RichTextBox/DataChip/base64-unicode-utils.js';
export default {
	name: 'TextParserChip',
	components: { NodeViewWrapper },
	props: nodeViewProps,
	computed: {
		params() {
			return this.node.attrs;
		},
		contentObj() {
			return JSON.parse(b64DecodeUnicode(this.node.attrs.content)); // We convert to base64 in replaceAllDelimitedDataToTipTapFormat, so here we decode it
		},
		text() {
			return this.contentObj.content;
		},
	},
	methods: {},
};
</script>

<style scoped lang="scss">
.text-parser-chip {
	border: none;
	display: inline;
	position: relative;
	border-radius: 3px;
	margin: 1rem 2px 1rem 0;
	align-items: center;
	height: 0px;
	padding: 0px;
	display: inline-flex;
	vertical-align: middle;
	.content-display {
		display: inline;
		border-radius: 8px;
		background: rgb(231, 231, 143);
		border: 1px solid var(--border-color);
		&:hover {
			transition: 0.2s;
			box-shadow: var(--card-shadow);
		}
		.value-text {
			font-size: 12px;
			margin-top: -2px;
			display: inline-flex;
			vertical-align: middle;
			color: var(--primary-font-color);
		}
		.close-button {
			width: 14px;
			height: 30px;
			padding: 0px;
			margin-top: -1px;
			display: inline-flex;
			vertical-align: middle;
			background: transparent;
			.close-icon {
				font-size: 12px;
			}
		}
	}
}
</style>
